/* StudioSoie · Accueil direction D — interactions (vanilla, sans dépendance)
   Chargé en defer par chaque section ss-home-* ; s'exécute une seule fois. */
(function () {
  'use strict';
  if (window.SSH) { return; }
  var SSH = window.SSH = { version: '1.2.0' };

  var T = Object.assign({
    added: 'Ajouté au panier',
    error: 'Impossible d’ajouter cet article',
    choose: 'Choisir',
    add: 'Ajouter au panier',
    unavailable: 'Indisponible',
    close: 'Fermer',
    qty: 'Quantité',
    minus: 'Diminuer la quantité',
    plus: 'Augmenter la quantité',
    buy2: 'Acheter par 2 · −[pct] %',
    view: 'Voir la fiche produit',
    buy2_on: false,
    buy2_pct: 10
  }, window.SSH_T || {});

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || document.documentElement.getAttribute('data-ssh-currency') || 'EUR';
  var lang = document.documentElement.lang || 'fr';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var v = cents / 100;
    var digits = Math.abs(v - Math.round(v)) < 0.005 ? 0 : 2;
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v); }
    catch (e) { return v.toFixed(digits) + ' ' + currency; }
  }
  SSH.money = money;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, '').replace(/[–—×]/g, 'x'); }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'ssh-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  SSH.toast = toast;

  /* ---------- Panier ---------- */
  function refreshCartCount() {
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error('cart'); } return r.json(); }).then(function (cart) {
      qsa('[data-ssh-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('ssh:cart', { detail: cart }));
    }).catch(function () {});
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) { throw new Error('cart'); } return r.json(); }).then(function (res) { refreshCartCount(); return res; });
  }
  SSH.addItems = addItems;

  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error('product'); } return r.json(); });
    }
    return productCache[handle];
  }

  /* ---------- Feuille quick-add ---------- */
  var sheet;
  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'ssh-sheet';
    sheet.innerHTML = '<div class="ssh-sheet__bg" data-close></div><div class="ssh-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="ssh-sheet-title">' +
      '<div class="ssh-sheet__head"><a class="ssh-sheet__media" data-link href="#" aria-label="' + T.view + '"><img alt="" data-img></a><div class="ssh-sheet__info"><a class="ssh-sheet__title" id="ssh-sheet-title" data-title data-link href="#"></a><div class="ssh-sheet__price" data-price></div><a class="ssh-sheet__view" data-link href="#">' + T.view + ' <span aria-hidden="true">→</span></a></div>' +
      '<button type="button" class="ssh-sheet__close" data-close aria-label="' + T.close + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="ssh-sheet__opts" data-opts></div>' +
      '<div class="ssh-sheet__cta"><div class="ssh-sheet__foot">' +
        '<div class="ssh-qty" role="group" aria-label="' + T.qty + '"><button type="button" class="ssh-qty__b" data-qty="-1" aria-label="' + T.minus + '">−</button><input class="ssh-qty__n" type="number" inputmode="numeric" min="1" max="20" value="1" aria-label="' + T.qty + '" data-qty-n><button type="button" class="ssh-qty__b" data-qty="1" aria-label="' + T.plus + '">+</button></div>' +
        '<button type="button" class="ssh-pill ssh-pill--ink ssh-sheet__add" data-add>' + T.add + '</button>' +
      '</div>' +
      '<button type="button" class="ssh-sheet__buy2" data-buy2 hidden></button></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) { closeSheet(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) { closeSheet(); } });
  }
  function closeSheet() { sheet.classList.remove('is-open'); }
  function openSheet(product, trigger) {
    if (!sheet) { buildSheet(); }
    var img = qs('[data-img]', sheet), title = qs('[data-title]', sheet), price = qs('[data-price]', sheet), opts = qs('[data-opts]', sheet), add = qs('[data-add]', sheet);
    var links = qsa('[data-link]', sheet), qtyN = qs('[data-qty-n]', sheet), buy2 = qs('[data-buy2]', sheet);
    var pct = parseFloat(T.buy2_pct) || 0, buy2On = !!T.buy2_on && pct > 0;
    var purl = product.url || (root + 'products/' + product.handle);
    qtyN.value = 1;
    var baseImg = product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
    img.src = baseImg; img.alt = product.title;
    title.textContent = product.title;
    opts.innerHTML = '';
    /* run 8 : options en pastilles (plus de menus déroulants), image de la variante mise à jour, combinaisons indisponibles grisées */
    var ci = -1; product.options.forEach(function (opt, i) { var nm = (opt && opt.name) ? opt.name : opt; if (ci < 0 && /couleur|coloris|colou?r|colore|farbe|kleur|farve|färg|farge|väri|barva|szín|kolor|χρώμα|culoare|\bcor\b|цвет|колір|צבע|لون/i.test(String(nm))) { ci = i; } });
    var chosen = [], groups = [];
    product.options.forEach(function (opt, i) {
      var name = (opt && opt.name) ? opt.name : opt;
      var values = []; product.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) { values.push(v.options[i]); } });
      var wrap = document.createElement('div'); wrap.className = 'ssh-sheet__opt';
      wrap.innerHTML = '<label>' + name + ' <b data-ssh-opt-val></b></label>';
      var row = document.createElement('div'); row.className = 'ssh-sheet__pills' + (i === ci ? ' ssh-sheet__pills--color' : '');
      values.forEach(function (val) {
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'ssh-sheet__pill'; bt.setAttribute('data-value', val); bt.setAttribute('aria-pressed', 'false');
        if (i === ci) {
          var vv = product.variants.filter(function (v) { return v.options[i] === val && v.featured_image && v.featured_image.src; })[0];
          if (vv) { bt.innerHTML = '<img src="' + vv.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2') + '" alt="" loading="lazy"><span>' + val + '</span>'; } else { bt.textContent = val; }
        } else { bt.textContent = val; }
        bt.addEventListener('click', function () { chosen[i] = val; paint(); resolve(); });
        row.appendChild(bt);
      });
      wrap.appendChild(row); opts.appendChild(wrap); groups.push({ wrap: wrap, row: row, index: i, values: values });
    });
    var prefColor = trigger ? (trigger.getAttribute('data-color') || '') : '';
    var first = null;
    if (prefColor && ci >= 0) { first = product.variants.filter(function (v) { return v.available && norm(v.options[ci]) === norm(prefColor); })[0] || product.variants.filter(function (v) { return norm(v.options[ci]) === norm(prefColor); })[0] || null; }
    if (!first) { first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0]; }
    if (first) { first.options.forEach(function (val, i) { chosen[i] = val; }); }
    var current = null;
    function available(i, val) {
      return product.variants.some(function (v) { if (!v.available || v.options[i] !== val) { return false; } return v.options.every(function (o, k) { return k === i || chosen[k] == null || o === chosen[k]; }); });
    }
    function paint() {
      groups.forEach(function (g) {
        var lab = qs('[data-ssh-opt-val]', g.wrap); if (lab) { lab.textContent = chosen[g.index] ? ': ' + chosen[g.index] : ''; }
        qsa('.ssh-sheet__pill', g.row).forEach(function (bt) { var val = bt.getAttribute('data-value'); var on = chosen[g.index] === val; bt.classList.toggle('is-on', on); bt.setAttribute('aria-pressed', on ? 'true' : 'false'); bt.classList.toggle('is-out', !available(g.index, val)); });
      });
    }
    function qty() { var n = parseInt(qtyN.value, 10); if (isNaN(n) || n < 1) { n = 1; } if (n > 20) { n = 20; } return n; }
    function resolve() {
      current = product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0] || null;
      var n = qty();
      if (current) {
        price.innerHTML = '<span class="ssh-sheet__now">' + money(current.price) + '</span>' + (current.compare_at_price > current.price ? ' <s>' + money(current.compare_at_price) + '</s>' : '');
        add.disabled = !current.available; add.textContent = current.available ? T.add + ' · ' + money(current.price * n) : T.unavailable;
        var src = current.featured_image && current.featured_image.src ? current.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : baseImg;
        if (src && img.getAttribute('src') !== src) { img.src = src; }
        links.forEach(function (a) { a.setAttribute('href', purl + (purl.indexOf('?') < 0 ? '?' : '&') + 'variant=' + current.id); });
        if (buy2On && current.available) {
          var full = current.price * 2, net = Math.round(full * (100 - pct) / 100);
          buy2.hidden = false; buy2.disabled = false;
          buy2.innerHTML = '<span>' + T.buy2.replace('[pct]', String(pct).replace('.', ',')) + '</span><span class="ssh-sheet__buy2-p"><s>' + money(full) + '</s> ' + money(net) + '</span>';
        } else { buy2.hidden = true; }
      } else {
        price.textContent = ''; add.disabled = true; add.textContent = T.unavailable; buy2.hidden = true;
        links.forEach(function (a) { a.setAttribute('href', purl); });
      }
    }
    paint(); resolve();
    function doAdd(btn, n) {
      if (!current) { return; }
      btn.disabled = true;
      addItems([{ id: current.id, quantity: n }]).then(function () { closeSheet(); toast(T.added); if (trigger) { trigger.classList.add('is-done'); setTimeout(function () { trigger.classList.remove('is-done'); }, 1800); } })
        .catch(function () { btn.disabled = false; toast(T.error); });
    }
    add.onclick = function () { doAdd(add, qty()); };
    buy2.onclick = function () { doAdd(buy2, 2); };
    qsa('[data-qty]', sheet).forEach(function (b) { b.onclick = function () { qtyN.value = Math.max(1, Math.min(20, qty() + parseInt(b.getAttribute('data-qty'), 10))); resolve(); }; });
    qtyN.oninput = resolve; qtyN.onchange = function () { qtyN.value = qty(); resolve(); };
    sheet.classList.add('is-open');
  }

  function quickAdd(btn) {
    var handle = btn.getAttribute('data-handle'), variant = btn.getAttribute('data-variant'), count = parseInt(btn.getAttribute('data-variants') || '1', 10);
    if (count <= 1 && variant) {
      btn.disabled = true;
      addItems([{ id: parseInt(variant, 10), quantity: 1 }]).then(function () { btn.disabled = false; btn.classList.add('is-done'); toast(T.added); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); })
        .catch(function () { btn.disabled = false; toast(T.error); });
      return;
    }
    getProduct(handle).then(function (p) {
      /* coloris déjà choisi sur la carte et pas d'autre option → ajout direct de la variante */
      if (btn.getAttribute('data-color') && variant && p.options && p.options.length === 1) {
        btn.disabled = true;
        addItems([{ id: parseInt(variant, 10), quantity: 1 }]).then(function () { btn.disabled = false; btn.classList.add('is-done'); toast(T.added); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); })
          .catch(function () { btn.disabled = false; toast(T.error); });
        return;
      }
      openSheet(p, btn);
    }).catch(function () { window.location.href = root + 'products/' + handle; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ssh-quick]');
    if (!btn) { return; }
    e.preventDefault(); e.stopPropagation();
    quickAdd(btn);
  });

  /* ---------- Pastilles de coloris des cartes : image, variante du bouton +, lien ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-ssh-swatch]');
    if (!sw) { return; }
    e.preventDefault(); e.stopPropagation();
    var card = sw.closest('[data-ssh-card], .ssh-quick, .ssh-card'); if (!card) { return; }
    qsa('[data-ssh-swatch]', card).forEach(function (x) { var on = x === sw; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var img = qs('.ssh-card__media img, .ssh-quick__img img', card), src = sw.getAttribute('data-img');
    /* srcset dérivé de l'URL CDN (…&width=480) : évite 4 URL par pastille dans le HTML */
    var srcset = sw.getAttribute('data-srcset') || (src && /[?&]width=\d+/.test(src) ? [240, 360, 480, 720].map(function (w) { return src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ') : '');
    if (img && src && img.getAttribute('src') !== src) {
      var pre = new Image();
      pre.onload = function () {
        if (card._sw !== sw) { return; }
        img.classList.add('is-swapping');
        if (srcset) { img.setAttribute('srcset', srcset); } else { img.removeAttribute('srcset'); }
        img.src = src;
        var done = function () { img.classList.remove('is-swapping'); };
        if (img.complete) { setTimeout(done, 40); } else { img.addEventListener('load', done, { once: true }); }
      };
      card._sw = sw; pre.src = src;
    }
    var vid = sw.getAttribute('data-variant'), color = sw.getAttribute('data-color'), avail = sw.getAttribute('data-available') === 'true';
    var btn = qs('[data-ssh-quick]', card);
    if (btn) { if (vid) { btn.setAttribute('data-variant', vid); } btn.setAttribute('data-color', color || ''); btn.classList.toggle('is-out', !avail); btn.disabled = !avail; }
    if (card.tagName === 'A' && vid) { var href = card.getAttribute('href') || ''; card.setAttribute('href', href.split('?')[0] + '?variant=' + vid); }
    var nameEl = qs('[data-ssh-swatch-name]', card); if (nameEl) { nameEl.textContent = color || ''; }
  });

  /* ---------- Nav flottante ---------- */
  var nav = qs('[data-ssh-nav]');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('is-scrolled', window.scrollY > 80); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Révélation ---------- */
  var reveals = qsa('[data-ssh-reveal]');
  if (reveals.length && !reduced && 'IntersectionObserver' in window) {
    reveals.forEach(function (el, i) { el.classList.add('ssh-reveal'); if (el.getAttribute('data-ssh-reveal')) { el.classList.add('ssh-reveal--' + el.getAttribute('data-ssh-reveal')); } });
    var ioAlive = false;
    var io = new IntersectionObserver(function (entries) {
      ioAlive = true;
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
    setTimeout(function () { reveals.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) { el.classList.add('is-in'); } }); }, 300);
    setTimeout(function () { if (!ioAlive) { reveals.forEach(function (el) { el.classList.add('is-in'); }); } }, 4000);
  }

  /* ---------- Chips « Par besoin » → le rail charge les produits de la collection (API de rendu de section) ---------- */
  var feedCache = {};
  function feedFor(handle) {
    if (!feedCache[handle]) {
      feedCache[handle] = fetch(root + 'collections/' + encodeURIComponent(handle) + '?section_id=ss-home-rail-feed', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) { throw new Error('feed'); } return r.text(); })
        .then(function (html) {
          var doc = document.implementation.createHTMLDocument(''); doc.body.innerHTML = html;
          var feed = doc.querySelector('[data-ssh-feed]');
          if (!feed || !feed.querySelector('[data-ssh-card]')) { throw new Error('empty'); }
          return { html: feed.innerHTML, count: parseInt(feed.getAttribute('data-count') || '0', 10), url: feed.getAttribute('data-url') || '' };
        })
        .catch(function (e) { delete feedCache[handle]; throw e; });
    }
    return feedCache[handle];
  }
  qsa('[data-ssh-chips]').forEach(function (group) {
    var rail = qs('[data-ssh-rail-home]') || qs('[data-ssh-rail]');
    var track = rail ? qs('[data-ssh-track]', rail) : null;
    var hint = rail ? qs('[data-ssh-rail-hint]', rail) : null;
    var home = track ? track.innerHTML : '';
    var seq = 0;
    function setTrack(html) { if (!track) { return; } track.innerHTML = html; track.scrollTo({ left: 0, behavior: 'auto' }); track.dispatchEvent(new Event('scroll')); }
    function setHint(text) { if (hint) { hint.textContent = text || hint.getAttribute('data-default') || ''; } }
    group.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ssh-chip]');
      if (!chip) { return; }
      if (chip.tagName === 'A' && chip.getAttribute('data-ssh-chip') === 'link') { return; }
      e.preventDefault();
      var key = chip.getAttribute('data-ssh-chip'), label = (chip.textContent || '').trim(), href = chip.getAttribute('href');
      qsa('[data-ssh-chip]', group).forEach(function (c) { c.classList.toggle('is-on', c === chip); });
      var my = ++seq;
      if (key === 'all' || !track) {
        if (track) { setTrack(home); setHint(''); qsa('[data-ssh-card]', track).forEach(function (c) { c.hidden = false; }); }
        return;
      }
      track.classList.add('is-loading');
      feedFor(key).then(function (feed) {
        if (my !== seq) { return; }
        var more = '';
        if (feed.count > 0 && href && href !== '#') {
          more = '<a class="ssh-rail__more" href="' + href + '">' + label + ' · ' + feed.count + ' →</a>';
        }
        setTrack(feed.html + more);
        setHint(label + (feed.count ? ' · ' + feed.count : ''));
        track.classList.remove('is-loading');
        if (rail) { var r = rail.getBoundingClientRect(); if (r.top < 0 || r.top > window.innerHeight * .8) { rail.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); } }
      }).catch(function () {
        if (my !== seq) { return; }
        track.classList.remove('is-loading');
        /* repli : filtre de la sélection manuelle par collection, puis lien si rien */
        setTrack(home);
        var cards = qsa('[data-ssh-card]', track), shown = 0;
        cards.forEach(function (card) { var ok = (card.getAttribute('data-collections') || '').split(' ').indexOf(key) >= 0; card.hidden = !ok; if (ok) { shown++; } });
        if (!shown) { cards.forEach(function (card) { card.hidden = false; }); if (href && href !== '#') { window.location.href = href; } }
      });
    });
  });

  /* ---------- Tuile « Meilleures ventes » : mini-slider (défilement auto, points, pause au survol) ---------- */
  qsa('[data-ssh-quickslider]').forEach(function (box) {
    var track = qs('[data-ssh-qtrack]', box), dots = qsa('[data-ssh-qdot]', box), slides = qsa('[data-ssh-qslide]', box);
    if (!track || slides.length < 2) { return; }
    var interval = parseInt(box.getAttribute('data-interval') || '0', 10), timer = null, paused = false, idx = 0;
    function go(i, smooth) { idx = (i + slides.length) % slides.length; track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: smooth === false || reduced ? 'auto' : 'smooth' }); }
    function sync() { var w = track.clientWidth || 1; var i = Math.round(track.scrollLeft / w); if (i !== idx) { idx = Math.max(0, Math.min(slides.length - 1, i)); } dots.forEach(function (d, k) { var on = k === idx; d.classList.toggle('is-on', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); }); }
    function start() { stop(); if (interval > 0 && !paused && !reduced && document.visibilityState === 'visible') { timer = setInterval(function () { go(idx + 1); }, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function (e) { e.preventDefault(); go(k); start(); }); });
    box.addEventListener('mouseenter', function () { paused = true; stop(); });
    box.addEventListener('mouseleave', function () { paused = false; start(); });
    box.addEventListener('focusin', function () { paused = true; stop(); });
    box.addEventListener('focusout', function () { paused = false; start(); });
    track.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; setTimeout(start, 4000); }, { passive: true });
    document.addEventListener('visibilitychange', start);
    if ('IntersectionObserver' in window) { var qio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { start(); } else { stop(); } }, { threshold: .4 }); qio.observe(box); } else { start(); }
    sync();
  });

  /* ---------- Avis clients : défilement doux (points, flèches, pause au survol) ---------- */
  qsa('[data-ssh-reviews]').forEach(function (box) {
    var track = qs('[data-ssh-rtrack]', box), items = qsa('[data-ssh-ritem]', box), dots = qsa('[data-ssh-rdot]', box);
    if (!track || items.length < 2) { return; }
    var interval = parseInt(box.getAttribute('data-interval') || '0', 10), timer = null, paused = false, idx = 0;
    function go(i) { idx = (i + items.length) % items.length; track.scrollTo({ left: items[idx].offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); }
    function sync() { var w = track.clientWidth || 1; idx = Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / (w + 24)))); dots.forEach(function (d, k) { var on = k === idx; d.classList.toggle('is-on', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); }); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (interval > 0 && !paused && !reduced && document.visibilityState === 'visible') { timer = setInterval(function () { go(idx + 1); }, interval); } }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    var prev = qs('[data-ssh-rprev]', box), next = qs('[data-ssh-rnext]', box);
    if (prev) { prev.addEventListener('click', function () { go(idx - 1); start(); }); }
    if (next) { next.addEventListener('click', function () { go(idx + 1); start(); }); }
    box.addEventListener('mouseenter', function () { paused = true; stop(); });
    box.addEventListener('mouseleave', function () { paused = false; start(); });
    box.addEventListener('focusin', function () { paused = true; stop(); });
    box.addEventListener('focusout', function () { paused = false; start(); });
    track.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; setTimeout(start, 5000); }, { passive: true });
    document.addEventListener('visibilitychange', start);
    if ('IntersectionObserver' in window) { var rio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { start(); } else { stop(); } }, { threshold: .4 }); rio.observe(box); } else { start(); }
    sync();
  });

  /* ---------- Rail : barre de progression ---------- */
  qsa('[data-ssh-track]').forEach(function (track) {
    var bar = qs('[data-ssh-bar]', track.parentNode);
    if (!bar) { return; }
    var update = function () { var max = track.scrollWidth - track.clientWidth; var p = max > 0 ? track.scrollLeft / max : 0; bar.style.transform = 'translateX(' + Math.round(p * 178) + '%)'; };
    track.addEventListener('scroll', update, { passive: true }); update();
  });

  /* ---------- Sélecteur de momme ---------- */
  qsa('[data-ssh-momme]').forEach(function (box) {
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-value]'); if (!b) { return; }
      qsa('button[data-value]', box).forEach(function (x) { x.classList.toggle('is-on', x === b); });
      qsa('[data-ssh-momme-text]', box).forEach(function (t) { t.hidden = t.getAttribute('data-ssh-momme-text') !== b.getAttribute('data-value'); });
    });
  });

  /* ---------- Configurateur de lit ---------- */
  qsa('[data-ssh-builder]').forEach(function (b) {
    var layers = qsa('[data-ssh-layer]', b);
    var totalEl = qs('[data-ssh-total]', b), addBtn = qs('[data-ssh-add-all]', b), sizeBtns = qsa('[data-ssh-size]', b);
    var size = (qs('[data-ssh-size].is-on', b) || sizeBtns[0] || {}).getAttribute ? (qs('[data-ssh-size].is-on', b) || sizeBtns[0]).getAttribute('data-ssh-size') : '';
    var loaded = false;
    function findIdx(product, names) { var idx = -1; product.options.forEach(function (n, i) { var nm = (n && n.name) ? n.name : n; if (idx < 0 && names.some(function (k) { return norm(nm).indexOf(k) >= 0; })) { idx = i; } }); return idx; }
    function resolve(layer) {
      var p = layer._product; if (!p) { return; }
      var color = layer.getAttribute('data-color') || '', fixed = layer.getAttribute('data-fixed-size') || '';
      var want = fixed || size;
      var si = findIdx(p, ['taille', 'size', 'dimension']), ci = findIdx(p, ['couleur', 'color', 'coloris']);
      var match = p.variants.filter(function (v) {
        var okS = si < 0 || !want || norm(v.options[si]) === norm(want);
        var okC = ci < 0 || !color || norm(v.options[ci]) === norm(color);
        return okS && okC;
      });
      var v = match.filter(function (x) { return x.available; })[0] || match[0] || null;
      layer._variant = v;
      var priceEl = qs('[data-ssh-layer-price]', layer), sub = qs('[data-ssh-layer-sub]', layer);
      var qty = parseInt(layer.getAttribute('data-qty') || '1', 10);
      if (v && v.available) { layer.classList.remove('is-unavailable'); priceEl.textContent = money(v.price * qty); if (sub) { sub.textContent = v.title; } }
      else { layer.classList.add('is-unavailable'); priceEl.textContent = T.unavailable; if (sub) { sub.textContent = ''; } }
    }
    function total() {
      var sum = 0, n = 0;
      layers.forEach(function (l) { var v = l._variant, on = l.getAttribute('data-on') === 'true'; if (on && v && v.available) { sum += v.price * parseInt(l.getAttribute('data-qty') || '1', 10); n++; } });
      if (totalEl) { totalEl.textContent = money(sum); }
      if (addBtn) { addBtn.disabled = n === 0; var tpl = addBtn.getAttribute('data-label') || ''; addBtn.textContent = tpl.replace('{n}', n); }
    }
    function load() {
      if (loaded) { return; } loaded = true;
      layers.forEach(function (l) { getProduct(l.getAttribute('data-handle')).then(function (p) { l._product = p; resolve(l); total(); }).catch(function () { l.classList.add('is-unavailable'); total(); }); });
    }
    SSH.loadBuilders = SSH.loadBuilders || []; SSH.loadBuilders.push(load);
    if ('IntersectionObserver' in window) { var bio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { load(); bio.disconnect(); } }, { rootMargin: '400px' }); bio.observe(b); } else { load(); }
    setTimeout(function () { if (document.visibilityState === 'visible') { load(); } }, 5000);
    sizeBtns.forEach(function (sb) { sb.addEventListener('click', function () { load(); size = sb.getAttribute('data-ssh-size'); sizeBtns.forEach(function (x) { x.classList.toggle('is-on', x === sb); }); layers.forEach(resolve); total(); }); });
    layers.forEach(function (l) {
      var t = qs('[data-ssh-toggle]', l), hot = qs('[data-ssh-hot="' + l.getAttribute('data-index') + '"]', b);
      if (!t) { return; }
      t.addEventListener('click', function () { load(); var on = l.getAttribute('data-on') !== 'true'; l.setAttribute('data-on', on ? 'true' : 'false'); t.setAttribute('aria-pressed', on ? 'true' : 'false'); l.classList.toggle('is-off', !on); if (hot) { hot.classList.toggle('is-off', !on); } total(); });
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        layers.forEach(function (l) { var v = l._variant; if (l.getAttribute('data-on') === 'true' && v && v.available) { items.push({ id: v.id, quantity: parseInt(l.getAttribute('data-qty') || '1', 10) }); } });
        if (!items.length) { return; }
        addBtn.disabled = true;
        addItems(items).then(function () { addBtn.disabled = false; toast(T.added); }).catch(function () { addBtn.disabled = false; toast(T.error); });
      });
    }
    total();
  });

  /* ---------- Newsletter : message de confirmation ---------- */
  if (/customer_posted=true/.test(window.location.search)) { var m = qs('[data-ssh-news-ok]'); if (m) { m.hidden = false; } }

  refreshCartCount();
})();
